import {
  ApiBlueprint,
  createFrontendModule,
  pluginHeaderActionsApiRef,
  toastApiRef,
} from '@backstage/frontend-plugin-api';
import { SignInPageBlueprint } from '@backstage/plugin-app-react';
import {
  SignInPage,
  SignInProviderConfig,
} from '@backstage/core-components';
import { microsoftAuthApiRef } from '@backstage/core-plugin-api';

const azureAuthProvider: SignInProviderConfig = {
  id: 'azure-auth-provider',
  title: 'Microsoft AD',
  message: 'Sign in using Danfoss AD',
  apiRef: microsoftAuthApiRef,
};

const pluginHeaderActionsApi = ApiBlueprint.make({
  name: 'plugin-header-actions',
  params: defineParams =>
    defineParams({
      api: pluginHeaderActionsApiRef,
      deps: {},
      factory: () => ({
        getPluginHeaderActions: () => [],
      }),
    }),
});

const toastApi = ApiBlueprint.make({
  name: 'toast',
  params: defineParams =>
    defineParams({
      api: toastApiRef,
      deps: {},
      factory: () => ({
        post: () => ({ close: () => {} }),
      }),
    }),
});

const signInPage = SignInPageBlueprint.make({
  params: {
    loader: async () => props => (
      <SignInPage {...props} providers={[azureAuthProvider]} />
    ),
  },
});

export const authModule = createFrontendModule({
  pluginId: 'app',
  extensions: [pluginHeaderActionsApi, toastApi, signInPage],
});
